import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import * as PropTypes from "prop-types";
import { DatePicker } from "@mui/x-date-pickers";
import cloneDeep from "lodash.clonedeep";
import Badge from "@mui/material/Badge";
import dayjs from "dayjs";
import { getMealsForDay } from "../../util/meal-helper";
import { useMealPlanner } from "../../context-providers/meal-planner-provider";
import { useHome } from "../../context-providers/home-provider";
import { Meal, Recipe } from "../../types";
import { margin } from "@mui/system";

AddMealDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  recipe: PropTypes.shape({}),
  addMeal: PropTypes.func.isRequired,
};

AddMealDialog.defaultProps = {
  recipe: null,
};
export default function AddMealDialog(props: any) {
  const { recipe, open, handleClose, addMeal } = props;
  const initialMeal: Meal = cloneDeep({ ...recipe, date: new Date() });
  const [meal, setMeal] = useState<Meal | undefined>(initialMeal);
  const { userMeals, homeMeals } = useMealPlanner();
  const { home } = useHome();

  const isHome = home && !!home.id;
  const meals = isHome ? homeMeals : userMeals;

  useEffect(() => {
    setMeal(initialMeal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.recipe]);

  if (!meal) {
    return <div />;
  }

  function isMealValid() {
    return meal && meal.serves && meal.serves > 0 && meal.date;
  }

  return (
    <Dialog
      open={open}
      onClose={() => props.handleClose()}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Add to Meal Plan</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Choose the serving size and date you will be making this meal (You can
          change this later)
        </DialogContentText>
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            marginTop: "16px",
          }}
        >
          <TextField
            label="Serves"
            type="number"
            value={meal.serves}
            onChange={(event: any) =>
              setMeal({ ...meal, serves: parseInt(event.target.value, 10) })
            }
            error={!meal.serves || meal.serves <= 0}
            inputProps={{ min: "1", step: "1" }}
            InputLabelProps={{ shrink: true }}
          />
          <DatePicker
            label="Date"
            format="DD MMM YYYY"
            value={meal.date ? dayjs(meal.date) : null}
            onChange={(date: any) =>
              setMeal({ ...meal, date: date ? date.toDate() : null })
            }
            disablePast
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose()}>Cancel</Button>
        <Button
          disabled={!isMealValid()}
          onClick={() => addMeal(meal)}
          variant="contained"
          color="primary"
        >
          Add Meal
        </Button>
      </DialogActions>
    </Dialog>
  );
}
